export class AppConstants {

    // metide server
    //public static SITE_URL = 'https://hqsol.metide.com/';
    //public static IMAGE_URL = 'https://hqsol.metide.com/storage/';

    // hqsol live server
    public static SITE_URL = 'https://backend.portaless.hqsol.it/';
    public static IMAGE_URL = 'https://backend.portaless.hqsol.it/storage/';

    // local
    // public static SITE_URL = 'http://delios-backend.local/';
    // public static IMAGE_URL = 'http://delios-backend.local/storage/';
}



// WEBPACK FOOTER //
// /var/www/hqsol/hqsol-live/app/src/app/constant/app.constants.ts